import React from "react";
import { Box, Container } from "@mui/material";
import Card from "../Card/Card";
import Microsoft from "../../assets/images/microsoft.svg";
import Deepgram from "../../assets/images/deepgram.svg";
import Sambanava from "../../assets/images/sambanova.png";
import Groq from "../../assets/images/groq.png";
import Hume from "../../assets/images/hume.png";
import Nvidia from "../../assets/images/nvidia.png";
import Aws from "../../assets/images/aws.png";
import { motion } from "framer-motion";
import Slider from "react-slick";
import { Colors } from "../../assets/colors";

function Ourpartners() {
  
  const customImageWidth = {
    xs: "85%", // Reduced from 65%
    sm: "60%", // Reduced from 90%
    md: "45%", // Reduced from 85%
    lg: "60%", // Reduced from 80%
    xl: "85%", // Reduced from 70%
  };
  const customImageWidthSecond = {
    xs: "55%", // Reduced from 95%
    sm: "60%", // Reduced from 90%
    md: "30%", // Reduced from 85%
    lg: "40%", // Reduced from 80%
    xl: "55%", // Reduced from 100%
  };
  const customImageWidthThird = {
    xs: "60%", // Reduced from 95%
    sm: "60%", // Reduced from 90%
    md: "35%", // Reduced from 85%
    lg: "40%", // Reduced from 80%
    xl: "55%", // Reduced from 100%
  };
  const customImageWidthFourth = {
    xs: "90%", // Reduced from 95%
    sm: "60%", // Reduced from 90%
    md: "45%", // Reduced from 85%
    lg: "60%", // Reduced from 80%
    xl: "85%", // Reduced from 100%
  };
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  
  const CardBody = (
    <Box sx={styles.cardBodyContainer}>
    <Slider
        {...settings}
        style={{
          width: "100%",
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
      {[Aws, Deepgram, Groq, Hume, Microsoft, Nvidia, Sambanava].map(
        (image, index) => (
          <Box
            key={index}
            sx={{
              ...styles.boxImage,
              animation: `slideUp 0.5s ease-out ${index * 0.2}s both`,
              opacity: 0,
              display: "flex !important",
              justifyContent: "center !important",
              alignItems: "center !important",
              "@keyframes slideUp": {
                "0%": {
                  transform: "translateY(50px)",
                  opacity: 0,
                },
                "100%": {
                  transform: "translateY(0)",
                  opacity: 1,
                },
              },
            }}
          >
            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={itemVariants}
                whileHover={{ scale: 1.05 }}
                style={{
                  width: "100%",
                  height: "100px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
            <Box
              component="img"
              src={image}
              alt={`Image ${index + 1}`}
              sx={{
                ...styles.image,
                width:
                  image === Groq
                    ? customImageWidthThird
                    : image === Aws
                    ? customImageWidthSecond 
                    : image === Hume
                    ? customImageWidthFourth
                    : customImageWidth,
                margin: "0 auto",
                display: "block",
              }}
            />
            </motion.div>
          </Box>
        )
      )}
      </Slider>
    </Box>
  );

  return (
    <Box sx={styles.appBarStyle}>
      
      <Container maxWidth="xl" sx={styles.containerStyle}>
        <Card
          paddingTop={{
            xs: 3, // mobile
            sm: 1, // tablet
            md: 1.5, // desktop
            lg: 2, // large desktop
            xl: 1.5, // large desktop
          }}
          paddingBottom={{
            xs: 3, // mobile
            sm: 1, // tablet
            md: 1.5, // desktop
            lg: 2, // large desktop
            xl: 1.5, // large desktop
          }}
          paddingLeft={{
            xs: 2, // mobile
            sm: 3, // tablet
            md: 4, // desktop
            lg: 5, // large desktop
            xl: 6, // large desktop
          }}
          paddingRight={{
            xs: 2, // mobile
            sm: 3, // tablet
            md: 4, // desktop
            lg: 5, // large desktop
            xl: 6, // large desktop
          }}
          width={{
            xs: "97%", // mobile
            sm: "95%", // tablet
            md: "85%", // desktop
            lg: "75%", // large desktop
            xl: "68%", // large desktop
          }}
         
        >
          {CardBody}
        </Card>
      </Container>
    </Box>
  );
}

export default Ourpartners;

const styles = {
  cardBodyContainer: {
    alignItems: "center",
    width: "100%",
    "& .slick-slide": {
      padding: {
        xs: "0 5px",
        sm: "0 8px",
        md: "0 10px",
        lg: "0 15px",
        xl: "0 19px"
      },
      display: "flex !important",
      justifyContent: "center",
    },
    "& .slick-dots": {
      bottom: {
        xs: -55,
        sm: -35,
        md: -60,
        lg: -70,
        xl: -50
      },
    },
    "& .slick-prev, & .slick-next": {
      zIndex: 1,
      "&:before": {
        color: Colors.andaihubTxt,
      },
    },
    "& .slick-prev": {
      left: {
        xs: -22,
        sm: -20,
        md: -25,
        lg: -30,
        xl: -60
      },
    },
    "& .slick-next": {
      right: {
        xs: -22,
        sm: -20,
        md: -25,
        lg: -30,
        xl: -60
      },
    },
  },
  appBarStyle: {
    background:
      "linear-gradient(to bottom, #fff 0%, #fff  50%,  #fff9e3 50%,  #fff9e3 100%)",
      
  },
  containerStyle: {
    width: "100%",
    paddingTop: { xs: 4, sm: 6, md: 8, lg: 10, xl: 5},
    paddingBottom: { xs: 4, sm: 6, md: 8, lg: 10, xl: 5 },
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    background:
    "linear-gradient(to bottom, #fff 0%, #fff  50%,  #fff9e3 50%,  #fff9e3 100%)",
  },
  image: {
    height: "auto",
    maxWidth: "100%",
    objectFit: "contain",
    display: "block",
    margin: "auto",
  },
   coreFeatureTxt:{
    textAlign:"center",
    paddingTop: { 
      xs: 2,  // 16px for mobile
      sm: 3,  // 24px for tablet
      md: 4,  // 32px for desktop
      lg: 5,  // 40px for large desktop
      xl: 0   // 48px for extra large screens
    }
  },
  boxImage: {
    display: "flex !important",
    justifyContent: "center !important",
    alignItems: "center !important",
    padding: {
      xs: 1,
      sm: 2.5,
      md: 3,
      lg: 3.5,
      xl: 4,
    },
    flex: {
      xs: "0 0 50%",
      sm: "0 0 33.33%",
      md: "0 0 20%",
    },
    minHeight: {
      xs: "80px",
      sm: "90px",
      md: "100px",
      lg: "110px",
    },

    boxSizing: "border-box",
    "&:last-child": {
      "@media (max-width: 600px)": {
        flex: "0 0 100%",
        alignSelf: "center",
        justifyContent: "center",
        justifyItems: "center",
        display: "flex",
      },
    },
  },
};
